import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/read/$id')({
  component: ReadPage,
});

function ReadPage() {
  return <Outlet />;
}
